(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  const init = (wrap) => {
    const count = parseInt(wrap.dataset.count, 10) || 1;
    if (count < 2) return;
    const track = wrap.querySelector('.egn-cslides__track');
    const dotsBox = wrap.querySelector('.egn-cslides__dots');
    let cur = 0, timer = null;
    const dots = [];
    for (let i = 0; i < count; i++) {
      const d = document.createElement('button');
      d.className = 'egn-cslides__dot';
      d.setAttribute('role', 'tab');
      d.setAttribute('aria-label', 'Slide ' + (i + 1));
      d.addEventListener('click', () => { go(i); restart(); });
      dotsBox.appendChild(d); dots.push(d);
    }
    const go = (i) => {
      cur = (i + count) % count;
      track.style.transform = 'translateX(-' + (cur * 100) + '%)';
      dots.forEach((d, k) => d.setAttribute('aria-selected', k === cur ? 'true' : 'false'));
      wrap.querySelectorAll('.egn-cslide video').forEach((v, k) => {
        const slide = v.closest('.egn-cslide');
        const idx = [...track.children].indexOf(slide);
        if (idx === cur) { v.play && v.play().catch(() => {}); } else { v.pause && v.pause(); }
      });
    };
    const iv = (parseInt(wrap.dataset.interval, 10) || 6) * 1000;
    const restart = () => { clearInterval(timer); timer = setInterval(() => go(cur + 1), iv); };
    wrap.querySelector('.egn-cslides__arrow--prev').addEventListener('click', () => { go(cur - 1); restart(); });
    wrap.querySelector('.egn-cslides__arrow--next').addEventListener('click', () => { go(cur + 1); restart(); });
    wrap.addEventListener('mouseenter', () => clearInterval(timer));
    wrap.addEventListener('mouseleave', restart);
    let sx = null;
    wrap.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; clearInterval(timer); }, { passive: true });
    wrap.addEventListener('touchend', (e) => {
      if (sx === null) return;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
      sx = null; restart();
    }, { passive: true });
    go(0); restart();
  };
  document.querySelectorAll('.egn-cslides').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
